// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTransferGiftTypeOptionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.EstateWaterfallWhereInput>;
}>;


export type GetTransferGiftTypeOptionsQuery = { __typename?: 'Query', estateWaterfalls: { __typename?: 'EstateWaterfallConnection', edges?: Array<{ __typename?: 'EstateWaterfallEdge', node?: { __typename?: 'EstateWaterfall', id: string, household: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<{ __typename?: 'ClientProfile', id: string, displayName: string }> } } | null } | null> | null } };

export const Operations = {
  Query: {
    GetTransferGiftTypeOptions: 'GetTransferGiftTypeOptions' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const GetTransferGiftTypeOptionsDocument = gql`
    query GetTransferGiftTypeOptions($where: EstateWaterfallWhereInput) {
  estateWaterfalls(where: $where) {
    edges {
      node {
        id
        household {
          id
          possiblePrimaryClients {
            id
            displayName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetTransferGiftTypeOptionsQuery__
 *
 * To run a query within a React component, call `useGetTransferGiftTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferGiftTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferGiftTypeOptionsQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useGetTransferGiftTypeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferGiftTypeOptionsQuery, GetTransferGiftTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferGiftTypeOptionsQuery, GetTransferGiftTypeOptionsQueryVariables>(GetTransferGiftTypeOptionsDocument, withFetchPolicyContext(options));
      }
export function useGetTransferGiftTypeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferGiftTypeOptionsQuery, GetTransferGiftTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferGiftTypeOptionsQuery, GetTransferGiftTypeOptionsQueryVariables>(GetTransferGiftTypeOptionsDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useGetTransferGiftTypeOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferGiftTypeOptionsQuery, GetTransferGiftTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferGiftTypeOptionsQuery, GetTransferGiftTypeOptionsQueryVariables>(GetTransferGiftTypeOptionsDocument, withFetchPolicyContext(options));
        }
export type GetTransferGiftTypeOptionsQueryHookResult = ReturnType<typeof useGetTransferGiftTypeOptionsQuery>;
export type GetTransferGiftTypeOptionsLazyQueryHookResult = ReturnType<typeof useGetTransferGiftTypeOptionsLazyQuery>;
export type GetTransferGiftTypeOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTransferGiftTypeOptionsSuspenseQuery>;
export type GetTransferGiftTypeOptionsQueryResult = Apollo.QueryResult<GetTransferGiftTypeOptionsQuery, GetTransferGiftTypeOptionsQueryVariables>;